'use client';

import { Box } from '@wishket/design-system';

import { CollectionArticleItem } from '@/features/Article';
import { CollectionArticleItemProps } from '@/shared/types';

const CollectionArticleItemWidget = ({
  id,
  href,
  title,
  author,
  isOwner,
  category,
  thumbnail,
  description,
  dateCreated,
  categoryHref,
  isVisibleUtil,
  isExternalContent,
  isVisibleCategory,
  onClickDelete,
}: CollectionArticleItemProps) => {
  return (
    <Box className="relative">
      <CollectionArticleItem
        id={id}
        href={href}
        title={title}
        author={author}
        isOwner={isOwner}
        category={category}
        thumbnail={thumbnail}
        description={description}
        dateCreated={dateCreated}
        categoryHref={categoryHref}
        isVisibleUtil={isVisibleUtil}
        isExternalContent={isExternalContent}
        isVisibleCategory={isVisibleCategory}
        onClickDelete={onClickDelete}
      />
    </Box>
  );
};

export default CollectionArticleItemWidget;
